<template>
  <el-container class="download-page-container">
    <el-main>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-container">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>app下载</el-breadcrumb-item>
      </el-breadcrumb>
      <h1 class="page-title">APP 下载</h1>
      <p class="page-description">选择您需要下载的设备 APP 版本。</p>

      <el-row :gutter="20" class="app-cards-wrapper">
        <el-col :xs="24" :sm="12" :md="8" class="app-card-col">
          <el-card class="app-download-card" shadow="hover">
            <div slot="header" class="clearfix">
              <i class="el-icon-truck app-icon"></i>
              <span>消防吊桶 APP</span>
            </div>
            <div class="card-content">
              <p>适用于管理和监控消防吊桶设备，实时查看设备状态和数据。</p>
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="downloadBucketApp"
                class="download-button"
              >
                <a download='bucket.apk' :href="this.downloadbucketpath"   >立即下载水桶 APP</a>
              </el-button>
            </div>
          </el-card>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" class="app-card-col">
          <el-card class="app-download-card" shadow="hover">
            <div slot="header" class="clearfix">
              <i class="el-icon-aim app-icon"></i>
              <span>清洗喷枪 APP</span>
            </div>
            <div class="card-content">
              <p>用于遥控和设置清洗喷枪设备，享受高效智能的清洗体验。</p>
              <el-button
                type="success"
                icon="el-icon-download"
                @click="downloadSprayGunApp"
                class="download-button"
              >
                <a download='gun.apk'   :href = 'this.downloadgunpath' >立即下载水枪 APP</a>
              </el-button>
            </div>
          </el-card>
        </el-col>

      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../utils/request'
export default {
  data () {
    return {
      appversions: [],
      bucketpath: '',
      gunpath: '',
      downloadbucketpath: '',
      downloadgunpath: ''
    }
  },
  mounted () {
    axios.get(`/data/appversion/query?productname=&pageNum=&pageSize=`).then(res => {
      console.log('res', res)
      this.appversions = res.data.list
      this.total = res.data.total
      for (const app of this.appversions) {
        console.log('app', app)
        console.log('app.productName', app.productName)
        if (app.productName === '水枪控制') {
          this.gunpath = app.path
        } else {
          this.bucketpath = app.path
        }
      }
      this.downloadgunpath = 'https://www.tjinnovations.cloud' + this.gunpath
      this.downloadbucketpath = 'https://www.tjinnovations.cloud' + this.bucketpath
    }).catch(error => {
      console.log('error', error)
    })
  },
  methods: {
    downloadBucketApp () {
      this.$message.success('消防吊桶 APP 开始下载...')
    },
    downloadSprayGunApp () {
      this.$message.success('清洗喷枪 APP 开始下载...')
    },
    downloadGeneralApp () {
      // 示例：通用APP下载
      // const downloadLink = 'https://example.com/download/general_app.apk'; // 替换为实际链接
      // window.open(downloadLink, '_blank');
      // this.$message.success('通用管理 APP 开始下载...');
    }
  }
}
</script>

<style scoped>
  .download-page-container {
    padding: 20px;
    background-color: #f0f2f5; /* 页面背景色 */
    min-height: calc(100vh - 60px); /* 假设头部高度为60px，撑满剩余空间 */
    display: flex;
    justify-content: center; /* 水平居中 */
  }

  .el-main {
    max-width: 1200px; /* 限制内容最大宽度 */
    width: 100%;
    padding: 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .page-title {
    text-align: center;
    color: #333;
    font-size: 28px;
    margin-bottom: 10px;
  }

  .page-description {
    text-align: center;
    color: #666;
    font-size: 16px;
    margin-bottom: 40px;
  }

  .app-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center; /* 让卡片在行内居中 */
  }

  .app-card-col {
    margin-bottom: 20px; /* 卡片之间的垂直间距 */
    display: flex; /* 让卡片在col中撑满高度 */
  }

  .app-download-card {
    width: 100%; /* 确保卡片占据列的全部宽度 */
    border-radius: 8px;
    display: flex;
    flex-direction: column;
  }

  .app-download-card .el-card__header {
    background-color: #f7f9fa;
    border-bottom: 1px solid #ebeef5;
    padding: 18px 20px;
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  .app-download-card .el-card__body {
    flex-grow: 1; /* 让内容区域填充剩余空间 */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* 将描述和按钮推开 */
  }

  .app-icon {
    margin-right: 10px;
    font-size: 24px;
    vertical-align: middle;
  }

  .card-content p {
    line-height: 1.6;
    color: #606266;
    margin-bottom: 20px; /* 描述和按钮之间的间距 */
    flex-grow: 1; /* 让描述撑开空间 */
  }

  .download-button {
    width: 100%;
    margin-top: auto; /* 按钮始终靠底 */
  }

  /* 清除浮动，Element UI 推荐的 .clearfix */
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DownloadPage.vue